import { render, staticRenderFns } from "./LocationAreaForm.vue?vue&type=template&id=f9779c6a&scoped=true"
import script from "./LocationAreaForm.vue?vue&type=script&lang=js"
export * from "./LocationAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9779c6a",
  null
  
)

export default component.exports